module.exports = __webpack_public_path__ + "static/media/closeIcon.bc4f5412.svg";